module.exports = __webpack_public_path__ + "img/icon_recruit_new_workplace.d51696f8.jpg";